// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function TermsHeader(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("span", {
                          children: Util.ReactStuff.s(props.title),
                          className: "font-extrabold text-3xl md:text-4xl"
                        }),
                    className: "container mx-auto "
                  }),
              className: "relative py-20 lg:py-24 xl:py-32 bg-prezzee-red text-white px-8"
            });
}

var make = TermsHeader;

export {
  make ,
}
/* Util Not a pure module */
